import React, { Component } from 'react';
import classNames from 'classnames';
import { findDOMNode } from 'react-dom';

import reduce from 'lodash/reduce';

import MenuItemUi from './desktop.menu.menu_item.ui.jsx';

function getMargins(el) {
  const $el = $(el);
  return {
    marginLeft: parseInt($el.css('margin-left')),
    marginRight: parseInt($el.css('margin-right')),
    marginTop: parseInt($el.css('margin-top')),
    marginBottom: parseInt($el.css('margin-bottom'))
  };
}


class MenuItem extends Component {
  
  componentDidMount() {
    this.fixMargins();
  }
  
  componentDidUpdate() {
    this.fixMargins();
  }

  fixMargins() {
    // if we have yet to set "nav link margins" via the theme,
    // pull out the margins on the a tag and apply them to the parent
    
    // TODO: Remove this hack. It was to deal with a CSS shift from originally
    // using margin on the anchor tags directly, to using them on their container
    // It will require that ALL themes no longer have a margin on the .nav-link-wrapper,
    // and instead they put their margin rule directly on the nav-link-super-wrapper
    var $this = $(findDOMNode(this));
    var $parent = $this.closest('.nav-link-super-wrapper');

    const parentHasMarginsSet = reduce(getMargins($parent), (result, value) => result + value) > 0;

    if (!parentHasMarginsSet) {
      $parent.css(getMargins($this));
    }

    $this.css('margin', 0);
  }
  
  render() {
    const {
      href,
      selected,
      target,
      menuItemId,
      children,
      shouldShowExternalOpeningMsg,
      onClick
    } = this.props;

    return (
      <MenuItemUi 
        href={href}
        shouldShowExternalOpeningMsg={shouldShowExternalOpeningMsg}
        target={target}
        className={classNames(
          'action-nav-link', 
          'nav-link-wrapper', 
          `desktop-menu-item-${menuItemId}`,
          {
            selected: selected
          }
        )}
        selected={selected}
        children={children}
        onClick={onClick}
      />
    );
    
  }
  
  
}


export default MenuItem;
